define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"Apparel/StructureItemActionMixin"
], function(declare,Copy,StructureItemActionMixin) {

	return declare([Copy, StructureItemActionMixin], {
		/**
		 * Add special controller for copy form
		 */
		onCreatePopupDefView: function(defView) {
			this._mixinActionView(defView);
		}
	});
});